import { FC, ReactNode } from 'react';
import { LoadingSpinner } from 'components';

export type BlockUIProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  fallbackCondition?: boolean;
  loading?: boolean;
  loadingElement?: ReactNode;
};

const BlockUI: FC<BlockUIProps> = ({
  children,
  fallback,
  fallbackCondition,
  loading,
  loadingElement,
}) => {
  if (loading)
    return loadingElement ? <>{loadingElement}</> : <LoadingSpinner />;

  return <>{fallbackCondition ? fallback : children}</>;
};

export default BlockUI;
